<template>
  <div>
    <table-render
      ref="tableRender"
      :config="tableConfig"
      height="55vh"
      rowKey="userId"
      :propData="{ query: { ...$props } }"
    />
  </div>
</template>

<script>
import { openContent } from './ApplyForCommissionContent.config';

export default {
  name: 'ApplyForCommissionContent',
  props: {
    //  []  存放上一页的id数组
    taxationIdList: {
      type: [Array],
      default: () => [],
      required: true
    },
    // 一级类目 int类型  1或者2
    invoiceCategory: {
      type: [Number, String],
      default: '',
      required: true
    },
    // 二级类目的id
    invoiceItemId: {
      type: [Number, String],
      default: '',
      required: true
    },
    //二级类目的名字
    itemName: {
      type: [Number, String],
      default: '',
      required: true
    },
    // 默认开票种类联动
    formOptions: {
      type: [Object],
      default: () => ({
        // addressList: [],
        defaultInvoicingTypeList: [], // 发票类别列表
        _invoiceItems: [] //发票类目
      }),
      required: true
    }
  },
  data() {
    return {
      tableConfig: openContent,
      tableSelection: []
    };
  },
  watch: {
    invoiceCategory: {
      handler: function() {
        this.$nextTick(() => {
          this.$refs.tableRender.init();
        });
      }
    },
    invoiceItemId: {
      handler: function() {
        this.$nextTick(() => {
          this.$refs.tableRender.init();
        });
      }
    }
  },
  computed: {
    propData() {
      return {
        taxationIdList: this.taxationIdList,
        invoiceCategory: this.invoiceCategory,
        invoiceItemId: this.invoiceItemId,
        itemName: this.itemName
      };
    }
  },
  components: {
    tableRender: () => import('@/components/tableRender/')
  }
};
</script>

<style scoped>
.el-table__expand-icon {
  color: #2196f3 !important;
}
</style>
